import {defineSlotRecipe} from '@chakra-ui/react3'

export const overlayRecipe = defineSlotRecipe({
    slots: ['form', 'body', 'fields', 'nameLabel', 'counter', 'footer'],
    base: {
        form: {
            h: '100%',
            display: 'flex',
            flexDirection: 'column'
        },
        body: {
            display: 'flex',
            flexDirection: 'column',
            paddingBlock: 0,
            flex: 1,
            minH: 0,
            overflowY: 'auto',
            overscrollBehavior: 'contain'
        },
        fields: {
            p: 'spacing-24',
            display: 'flex',
            flexDirection: 'column',
            gap: 'spacing-32'
        },
        nameLabel: {
            textStyle: 'body.small',
            color: 'text.primary'
        },
        counter: {
            textStyle: 'label.medium',
            color: 'text.tertiary'
        },
        footer: {
            flexShrink: 0,
            borderTopWidth: '1px',
            borderTopColor: 'blackAlpha.300'
        }
    }
})
